  var LRC = (window.LRC_LP_CONFIG || {});
  (function () {
    var root = document.querySelector('.lrc-lp-root');
    if (!root) return;

    var sellingPlan = root.getAttribute('data-selling-plan') || '';
    var pixelName = root.getAttribute('data-pixel-name') || 'caffyne-picker-sub';
    var suggested = parseInt(root.getAttribute('data-suggested-qty'), 10) || 0;
    var freeShip = (parseFloat(root.getAttribute('data-free-ship')) || 0) * 100; /* dollars → cents */
    var verts = [].slice.call(root.querySelectorAll('[data-lp-vertical]')).map(function (v) {
      return { el: v, min: parseInt(v.getAttribute('data-vmin'), 10) || 0, noun: v.getAttribute('data-vnoun') || 'items',
               title: v.getAttribute('data-vtitle') || '', done: v.getAttribute('data-vdone') || '', color: v.getAttribute('data-vcolor') || '#223F4E',
               chip: v.querySelector('[data-lp-vchip]'),
               tiles: [].slice.call(v.querySelectorAll('[data-flavor-variant]')) };
    });
    var minQty = verts.reduce(function (a, v) { return a + v.min; }, 0) || parseInt(root.getAttribute('data-min-qty'), 10) || 1; /* aggregate floor (slots sizing); per-vertical gates below */
    function firstUnmetVert() {
      for (var fi = 0; fi < verts.length; fi++) {
        var v = verts[fi], c = 0;
        v.tiles.forEach(function (f) { var vid = f.getAttribute('data-flavor-variant'); c += (qty[vid] || 0) * (canMap[vid] || 1); });
        if (c < v.min) return v;
      }
      return null;
    }
    function guideToUnmet() {
      var u = firstUnmetVert();
      var target = u ? u.el : root.querySelector('[data-lp-picker]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: u ? 'center' : 'start' });
      if (u && u.chip) {
        u.chip.classList.remove('lrc-chip-flash'); void u.chip.offsetWidth; /* restart the animation on repeat taps */
        u.chip.classList.add('lrc-chip-flash');
        setTimeout(function () { u.chip.classList.remove('lrc-chip-flash'); }, 1300);
      }
      return !!u;
    }
    /* desktop rail nav: arrows scroll ~2 cards; self-hide when the rail fits; fade drops at the end */
    verts.forEach(function (v) {
      var rail = v.el.querySelector('.lrc-lp-vert-rail');
      var wrap = v.el.querySelector('[data-lp-railwrap]');
      var nav = v.el.querySelector('[data-lp-vnav]');
      if (!rail || !nav) return;
      var prev = nav.querySelector('[data-lp-vprev]'), next = nav.querySelector('[data-lp-vnext]');
      function span() { var card = rail.querySelector('.lrc-lp-flavor--card'); return card ? (card.offsetWidth + 9) : 160; } /* snap exactly one card */
      function sync() {
        var scrollable = rail.scrollWidth > rail.clientWidth + 4;
        nav.hidden = !scrollable;
        var atStart = rail.scrollLeft <= 2;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
        if (wrap) wrap.classList.toggle('at-end', atEnd || !scrollable);
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -span(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: span(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
    var freeShipAlways = root.getAttribute('data-free-ship-always') === 'true';
    var freeShipCode = root.getAttribute('data-free-ship-code') || '';
    var giftCents = parseInt(root.getAttribute('data-gift-cents'), 10) || 0; /* Gear Drop retail value, folded into strike + savings */
    var ctaBelowTmpl = root.getAttribute('data-cta-below') || 'Add {remaining} more';
    var ctaMetLabel = root.getAttribute('data-cta-met') || 'Save 25%';

    function money(c) { return '$' + (c / 100).toFixed(2); } /* c = cents */

    /* ---------- Flavor steppers / cart ---------- */
    var flavors = Array.prototype.slice.call(root.querySelectorAll('[data-lp-flavor]'));
    var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-lp-cta]'));
    var totalQtyEls = Array.prototype.slice.call(root.querySelectorAll('[data-lp-total-qty]'));
    var subtotalEls = Array.prototype.slice.call(root.querySelectorAll('[data-lp-subtotal]'));
    var onetimeEls = Array.prototype.slice.call(root.querySelectorAll('[data-lp-onetime]'));
    var savingsEls = Array.prototype.slice.call(root.querySelectorAll('[data-lp-savings]'));
    var prefersRM = false; try { prefersRM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}
    var prevSub = 0, prevOne = 0, prevSav = 0, wasMet = false, tweenRAF = {}, markerProgress = 0, markerRAF = null;
    function tweenEls(key, els, from, to) {
      if (!els.length) return;
      if (tweenRAF[key]) { cancelAnimationFrame(tweenRAF[key]); tweenRAF[key] = null; }
      if (prefersRM || from === to) { els.forEach(function (el) { el.textContent = money(to); }); return; }
      var start = null, dur = 280;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3); /* ease-out, no overshoot */
        var val = Math.round(from + (to - from) * eased);
        els.forEach(function (el) { el.textContent = money(val); });
        if (p < 1) { tweenRAF[key] = requestAnimationFrame(step); } else { tweenRAF[key] = null; }
      }
      tweenRAF[key] = requestAnimationFrame(step);
    }
    function ascentSetMarker(p, len) {
      if (!ascentMarker || !ascentFill) return;
      var pt = ascentFill.getPointAtLength(Math.max(0, Math.min(1, p)) * len);
      ascentMarker.setAttribute('cx', pt.x); ascentMarker.setAttribute('cy', pt.y);
    }
    function ascentAnimateMarker(from, to, len) {
      if (markerRAF) { cancelAnimationFrame(markerRAF); markerRAF = null; }
      if (prefersRM) { ascentSetMarker(to, len); return; }
      var start = null, dur = 350;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        ascentSetMarker(from + (to - from) * e, len);
        if (p < 1) { markerRAF = requestAnimationFrame(step); } else { markerRAF = null; }
      }
      markerRAF = requestAnimationFrame(step);
    }
    var offerStack = root.querySelector('[data-lp-offerstack]');
    var heroProof = root.querySelector('[data-lp-hero-proof]');
    var ship = root.querySelector('[data-lp-ship]');
    var shipMsg = root.querySelector('[data-lp-ship-msg]');
    var ascentFill = root.querySelector('[data-lp-ascent-fill]');
    var ascentMarker = root.querySelector('[data-lp-ascent-marker]');
    var boxslots = root.querySelector('[data-lp-boxslots]');
    var slotsWrap = root.querySelector('[data-lp-slots]');
    var prevFilled = 0;
    var otpMap = {}; /* variantId -> one-time price (cents) */
    var subMap = {}; /* variantId -> subscribe price (cents) */
    var canMap = {}; /* variantId -> cans this tile counts as */
    var minCanPrice = 0; /* cents of the cheapest single can (data-cans==1); fallback = min per-can */
    var stickyInfo = root.querySelector('[data-lp-sticky-info]');
    var hdrCta = root.querySelector('[data-lp-hdr-cta]');
    var hdrCtaLabel = hdrCta && hdrCta.querySelector('[data-lp-hdr-cta-label]');
    var submitting = false;

    var qty = {}; /* variantId -> qty */

    function totals() {
      var totQ = 0, subC = 0, oneC = 0, canC = 0;
      flavors.forEach(function (f) {
        var vid = f.getAttribute('data-flavor-variant');
        var n = qty[vid] || 0;
        totQ += n; subC += n * (subMap[vid] || 0); oneC += n * (otpMap[vid] || 0); canC += n * (canMap[vid] || 1);
      });
      return { q: totQ, sub: subC, one: oneC, cans: canC }; /* sub/one in cents */
    }

    function fill(tmpl, remaining, noun) {
      return String(tmpl).split('{remaining}').join(remaining).split('{s}').join(remaining === 1 ? '' : 's').split('{noun}').join(noun || '');
    }

    function refresh() {
      var t = totals();
      var vstates = verts.map(function (v) {
        var c = 0;
        v.tiles.forEach(function (f) { var vid = f.getAttribute('data-flavor-variant'); c += (qty[vid] || 0) * (canMap[vid] || 1); });
        return { v: v, count: c, met: c >= v.min };
      });
      var met = verts.length ? vstates.every(function (st) { return st.met; }) : t.cans >= minQty;
      var firstUnmet = null;
      for (var vu = 0; vu < vstates.length; vu++) { if (!vstates[vu].met) { firstUnmet = vstates[vu]; break; } }
      var remaining = firstUnmet ? Math.max(0, firstUnmet.v.min - firstUnmet.count) : Math.max(0, minQty - t.cans);
      var remainNoun = firstUnmet ? firstUnmet.v.noun : '';
      /* requirement chips */
      vstates.forEach(function (st) {
        if (!st.v.chip || st.v.min === 0) return;
        if (st.met) { st.v.chip.textContent = '✓ ' + (st.v.done || (st.v.title.split(' ')[0] || '').toUpperCase()); st.v.chip.classList.add('is-done'); }
        else { st.v.chip.textContent = 'PICK ' + st.v.min + '+'; st.v.chip.classList.remove('is-done'); }
      });
      var savings = Math.max(0, t.one + giftCents - t.sub);

      totalQtyEls.forEach(function (el) { el.textContent = String(t.q); });
      tweenEls('sub', subtotalEls, prevSub, t.sub); prevSub = t.sub;
      var oneDisp = t.one + giftCents; tweenEls('one', onetimeEls, prevOne, oneDisp); prevOne = oneDisp;
      tweenEls('sav', savingsEls, prevSav, savings); prevSav = savings;

      /* Offer stack (struck total + sub total + savings) shows ONLY once the can minimum is met */
      if (offerStack) offerStack.hidden = !met;

      /* Hero proof swaps avatar module → risk-reversal list once the can minimum is met */
      if (heroProof) heroProof.classList.toggle('is-met', met);

      /* CTA states — disabled + "Add N more can(s)" until min met, then "Save 25% → $total" */
      ctas.forEach(function (btn) {
        var isSticky = btn.hasAttribute('data-lp-sticky-cta');
        btn.disabled = false; /* never hard-disable: below-min clicks guide to the first unmet vertical */
        btn.setAttribute('aria-disabled', met ? 'false' : 'true');
        btn.classList.toggle('is-unmet', !met);
        var lbl = btn.querySelector('.lrc-lp-cta-label');
        if (lbl) {
          if (isSticky && !met && t.cans === 0) { lbl.textContent = btn.getAttribute('data-idle-label') || lbl.textContent; }
          else if (met) {
            var wasC = t.one + giftCents;
            if (!isSticky && wasC > t.sub) {
              var escT = function (x) { return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
              lbl.innerHTML = escT(ctaMetLabel) + ' → <s>' + money(wasC) + '</s> ' + money(t.sub); /* strike = one-time + gift retail, matching the offer stack */
            } else { lbl.textContent = ctaMetLabel + ' → ' + money(t.sub); }
          }
          else if (verts.length && remainNoun) { lbl.textContent = 'Add ' + remaining + ' more ' + remainNoun; }
          else { lbl.textContent = fill(ctaBelowTmpl, remaining); }
        }
        if (isSticky) { btn.classList.toggle('is-ready', met); }
      });

      /* Header CTA active/checkout state keys off min */
      if (hdrCta && hdrCtaLabel) {
        hdrCtaLabel.textContent = met ? (hdrCta.getAttribute('data-label-active') || hdrCtaLabel.textContent) : (hdrCta.getAttribute('data-label-idle') || hdrCtaLabel.textContent);
        hdrCta.classList.toggle('is-checkout', met);
      }

      flavors.forEach(function (f) {
        var on = (qty[f.getAttribute('data-flavor-variant')] || 0) > 0;
        f.classList.toggle('is-active', on);
      });

      /* Free-shipping ASCENT bar — item-based; renders ONLY when the can minimum is met (same gate as offer stack) */
      if (ship && (freeShip > 0 || freeShipAlways)) {
        if (!met) {
          ship.hidden = true;
        } else {
          ship.hidden = false;
          var unlocked = freeShipAlways || (freeShip > 0 && t.sub >= freeShip);
          ship.classList.toggle('is-unlocked', unlocked);
          if (unlocked) {
            if (shipMsg) shipMsg.textContent = 'Free shipping unlocked';
          } else {
            var remCans = Math.ceil(Math.max(0, freeShip - t.sub) / minCanPrice);
            if (shipMsg) shipMsg.innerHTML = 'Add ' + remCans + ' more can' + (remCans === 1 ? '' : 's') + ' and get <span class="lrc-lp-ship-free">FREE shipping</span>!';
          }
          var progress = unlocked ? 1 : (freeShip > 0 ? Math.min(1, t.sub / freeShip) : 0);
          if (ascentFill) {
            var len = ascentFill.getTotalLength();
            var justReveal = met && !wasMet;
            ascentFill.style.strokeDasharray = len;
            if (justReveal && !prefersRM) {
              /* start empty, force reflow, then transition to target so the fill draws in from 0 */
              ascentFill.style.transition = 'none';
              ascentFill.style.strokeDashoffset = len;
              ascentFill.getBoundingClientRect();
              ascentFill.style.transition = '';
            }
            ascentFill.style.strokeDashoffset = (1 - progress) * len;
            ascentAnimateMarker(justReveal ? 0 : markerProgress, progress, len);
            markerProgress = progress;
          }
        }
      }

      /* Box slots — filledCount = Σ(qty) raw units (NOT cans); always one trailing empty once min met; cap 8 filled then +N */
      if (slotsWrap) {
        var seq = [];
        flavors.forEach(function (f) {
          var svid = f.getAttribute('data-flavor-variant');
          var sn = qty[svid] || 0;
          if (sn > 0) {
            var sim = f.querySelector('.lrc-lp-flavor-img img');
            var ssrc = sim ? sim.getAttribute('src') : '';
            for (var se = 0; se < sn; se++) { seq.push(ssrc); }
          }
        });
        var filledCount = seq.length;
        function slotHTML(idx, filled) {
          var isNew = filled && idx >= prevFilled && !prefersRM;
          var cls = 'lrc-lp-slot' + (filled ? ' is-filled' : '') + (isNew ? ' lrc-slot-in' : '');
          var style = (filled && seq[idx]) ? (' style="background-image:url(\'' + seq[idx] + '\')"') : '';
          return '<span class="' + cls + '"' + style + '></span>';
        }
        var hx = '';
        if (verts.length) {
          /* grouped by vertical: tinted fills, dashed empties up to each vertical's min */
          var gseq = 0;
          verts.forEach(function (v, gvi) {
            var c = 0, vseq = [];
            v.tiles.forEach(function (f) {
              var vid = f.getAttribute('data-flavor-variant');
              var n = qty[vid] || 0; var w = canMap[vid] || 1;
              var img = f.querySelector('.lrc-lp-flavor-img img');
              for (var r = 0; r < n; r++) vseq.push(img ? img.getAttribute('src') : null); /* one bubble per UNIT (variety pack shows once) */
              c += n * w; /* minimum gating still counts can-weight */
            });
            if (v.min === 0 && c === 0) return;
            var empties = Math.max(0, v.min - c);
            hx += '<span class="lrc-lp-slotgroup">';
            for (var gi = 0; gi < vseq.length; gi++) {
              var st = ' style="border-color:' + v.color + ';' + (vseq[gi] ? 'background-image:url(\'' + vseq[gi] + '\')' : 'background-color:' + v.color + '33') + '"';
              hx += '<span class="lrc-lp-slot is-filled' + (gseq >= prevFilled && !prefersRM ? ' lrc-slot-in' : '') + '"' + st + '></span>';
              gseq++;
            }
            for (var ge = 0; ge < empties; ge++) { hx += '<span class="lrc-lp-slot"></span>'; }
            hx += '</span>';
          });
          slotsWrap.innerHTML = hx;
          var stickyRowG = root.querySelector('[data-lp-sticky-slotrow]');
          if (stickyRowG) stickyRowG.innerHTML = hx.split('lrc-lp-slot').join('lrc-lp-msl');
          var stickyBtnG = root.querySelector('[data-lp-sticky-slots]');
          if (stickyBtnG) stickyBtnG.classList.toggle('is-complete', met);
          var bagN = root.querySelector('[data-lp-sticky-bagn]');
          if (bagN) { bagN.textContent = t.q; bagN.hidden = t.q === 0; }
          var boxBtnG = root.querySelector('[data-lp-boxslots-btn]');
          if (boxBtnG) boxBtnG.classList.toggle('is-complete', met);
          prevFilled = filledCount;
          return; /* grouped path replaces the single-product renderer below */
        }
        if (met) {
          var shown = Math.min(filledCount, 8);
          for (var i = 0; i < shown; i++) { hx += slotHTML(i, true); }
          if (filledCount > 8) { hx += '<span class="lrc-lp-slot-more">+' + (filledCount - 8) + '</span>'; }
          hx += slotHTML(-1, false); /* one trailing empty */
        } else {
          for (var j = 0; j < minQty; j++) { hx += slotHTML(j, j < filledCount); }
        }
        slotsWrap.innerHTML = hx;
        /* sticky mini-cart slots: same seq, compact (max 6 + counter), dashed empties below min */
        var stickyRow = root.querySelector('[data-lp-sticky-slotrow]');
        if (stickyRow) {
          var sxh = '';
          function miniSlot(idx, filled) {
            var mcls = 'lrc-lp-msl' + (filled ? ' is-filled' : '') + (filled && idx >= prevFilled && !prefersRM ? ' lrc-slot-in' : '');
            var mstyle = (filled && seq[idx]) ? (' style="background-image:url(\'' + seq[idx] + '\')"') : '';
            return '<span class="' + mcls + '"' + mstyle + '></span>';
          }
          if (met) {
            var mshown = Math.min(filledCount, 6);
            for (var mi = 0; mi < mshown; mi++) { sxh += miniSlot(mi, true); }
            if (filledCount > 6) { sxh += '<span class="lrc-lp-msl-more">+' + (filledCount - 6) + '</span>'; }
            sxh += miniSlot(-1, false);
          } else {
            for (var mj = 0; mj < minQty; mj++) { sxh += miniSlot(mj, mj < filledCount); }
          }
          stickyRow.innerHTML = sxh;
          var stickyBtn = root.querySelector('[data-lp-sticky-slots]');
          if (stickyBtn) stickyBtn.classList.toggle('is-complete', met);
          var boxBtn = root.querySelector('[data-lp-boxslots-btn]');
          if (boxBtn) boxBtn.classList.toggle('is-complete', met);
        }
        prevFilled = filledCount;
      }

      /* Reveal choreography + one-time savings shimmer on the below→above-min crossing */
      var justCrossed = met && !wasMet;
      if (justCrossed && !prefersRM) {
        var reveal = [];
        var rp = root.querySelector('[data-lp-offerstack] .lrc-lp-offer-prices');
        var rc = root.querySelector('[data-lp-offerstack] .lrc-lp-offer-chip');
        if (rp) { reveal.push(rp); }
        if (rc) { reveal.push(rc); }
        reveal = reveal.concat(Array.prototype.slice.call(root.querySelectorAll('.lrc-lp-risk-row')));
        if (ship && !ship.hidden) { reveal.push(ship); }
        reveal.forEach(function (el, i) {
          el.classList.remove('lrc-reveal'); void el.offsetWidth;
          el.style.animationDelay = (i * 40) + 'ms';
          el.classList.add('lrc-reveal');
        });
      }
      wasMet = met;
    }

    flavors.forEach(function (f) {
      var vid = f.getAttribute('data-flavor-variant');
      qty[vid] = 0;
      otpMap[vid] = parseInt(f.getAttribute('data-otp'), 10) || 0;
      subMap[vid] = parseInt(f.getAttribute('data-sub'), 10) || 0;
      canMap[vid] = parseInt(f.getAttribute('data-cans'), 10) || 1;
      var qtyEl = f.querySelector('[data-lp-qty]');
      f.querySelectorAll('[data-lp-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-lp-step'), 10);
          var next = Math.max(0, (qty[vid] || 0) + delta);
          qty[vid] = next;
          if (qtyEl) qtyEl.textContent = String(next);
          try { if (navigator.vibrate) navigator.vibrate(6); } catch (e) {}
          if (delta > 0 && !prefersRM) { var pim = f.querySelector('.lrc-lp-flavor-img img'); if (pim) { pim.classList.remove('lrc-pop'); void pim.offsetWidth; pim.classList.add('lrc-pop'); } }
          refresh();
        });
      });
    });

    /* Cheapest single can (data-cans == 1); fallback to min per-can price if no 1-can tile */
    flavors.forEach(function (f) {
      var vid = f.getAttribute('data-flavor-variant');
      var sub = subMap[vid] || 0, cans = canMap[vid] || 1;
      if (sub > 0 && cans === 1 && (minCanPrice === 0 || sub < minCanPrice)) { minCanPrice = sub; }
    });
    if (minCanPrice === 0) {
      flavors.forEach(function (f) {
        var vid = f.getAttribute('data-flavor-variant');
        var sub = subMap[vid] || 0, cans = canMap[vid] || 1;
        if (sub > 0) { var per = sub / cans; if (minCanPrice === 0 || per < minCanPrice) { minCanPrice = per; } }
      });
    }
    if (minCanPrice === 0) { minCanPrice = 1; }

    function firePixel(t) {
      try {
        if (window.fbq) {
          window.fbq('track', 'InitiateCheckout', { content_name: pixelName, num_items: t.q, value: t.sub / 100 });
        }
      } catch (e) {}
    }

    function checkout() {
      var t = totals();
      var gateOk = verts.length
        ? verts.every(function (v) { var c = 0; v.tiles.forEach(function (f) { var vid = f.getAttribute('data-flavor-variant'); c += (qty[vid] || 0) * (canMap[vid] || 1); }); return c >= v.min; })
        : t.cans >= minQty;
      if (submitting) return;
      if (!gateOk) { guideToUnmet(); return; }
      submitting = true;
      ctas.forEach(function (b) { b.disabled = true; });
      firePixel(t);

      var items = [];
      flavors.forEach(function (f) {
        var vid = f.getAttribute('data-flavor-variant');
        var q = qty[vid] || 0;
        if (q > 0) {
          var item = { id: parseInt(vid, 10), quantity: q };
          if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
          items.push(item);
        }
      });

      /* free gifts: qty-1 one-time lines + their 100%-off codes (checkout only runs once minimums are met) */
      var giftCodes = [];
      String(root.getAttribute('data-gift-lines') || '').split('|').forEach(function (gl) {
        if (!gl) return;
        var gp = gl.split(':');
        var gvid = parseInt(gp[0], 10);
        if (gvid) items.push({ id: gvid, quantity: 1 });
        if (gp[1]) giftCodes.push(gp[1]);
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed: ' + res.status);
        var shipUnlocked = freeShipAlways || (freeShip > 0 && t.sub >= freeShip);
        var codes = [];
        if (freeShipCode && shipUnlocked) codes.push(freeShipCode);
        giftCodes.forEach(function (gc) { if (codes.indexOf(gc) === -1) codes.push(gc); });
        window.location.href = codes.length ? ('/checkout?discount=' + codes.map(encodeURIComponent).join(',')) : '/checkout';
      })
      .catch(function (err) { submitting = false; refresh(); console.error('[lrc-lp-caffyne]', err); alert('Sorry — something went wrong building your box. Please try again.'); });
    }

    ctas.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var sgOk = verts.length
          ? verts.every(function (v) { var c = 0; v.tiles.forEach(function (f) { var vid = f.getAttribute('data-flavor-variant'); c += (qty[vid] || 0) * (canMap[vid] || 1); }); return c >= v.min; })
          : totals().cans >= minQty;
        if (btn.hasAttribute('data-lp-sticky-cta') && !sgOk) {
          guideToUnmet();
          return;
        }
        checkout(e);
      });
    });

    /* ---------- Scroll-to-picker ---------- */
    var picker = document.querySelector('.lrc-lp-root [data-lp-picker]');
    root.querySelectorAll('[data-lp-scroll-picker]').forEach(function (btn) {
      btn.addEventListener('click', function () { if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });

    /* ---------- Header CTA: dynamic by picker qty (reuses the same qty state + checkout()) ---------- */
    if (hdrCta) {
      hdrCta.addEventListener('click', function () {
        if (totals().cans >= minQty) { checkout(); }
        else if (picker) { picker.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }

    /* ---------- Header two-state swap (light TOP → navy SCROLLED past 60px) ---------- */
    (function () {
      var header = root.querySelector('[data-lp-header]');
      if (!header) return;

      /* Don't let the browser restore a scrolled position on reload/back-nav and leave the header in the wrong state */
      if ('scrollRestoration' in history) { try { history.scrollRestoration = 'manual'; } catch (e) {} }

      var ticking = false;
      function evalState() {
        var y = window.pageYOffset || window.scrollY || 0;
        if (y > 60) { header.classList.add('is-scrolled'); }
        else { header.classList.remove('is-scrolled'); }
        ticking = false;
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(evalState); } }, { passive: true });
      /* Evaluate on every load path so a reload-while-scrolled or bfcache restore can't start in the wrong state */
      window.addEventListener('DOMContentLoaded', evalState);
      window.addEventListener('load', evalState);
      window.addEventListener('pageshow', evalState);
      evalState();
    })();

    refresh();

    /* ---------- Gallery carousel ---------- */
    (function () {
      var gal = root.querySelector('[data-lp-gallery]');
      if (!gal) return;
      var track = gal.querySelector('[data-lp-gal-track]');
      var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-lp-gal-slide]'));
      if (slides.length <= 1) return;
      var dots = Array.prototype.slice.call(gal.querySelectorAll('[data-lp-gal-dot]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lp-gal-thumb]'));
      var counter = gal.querySelector('[data-lp-gal-count]');
      var idx = 0;
      function go(i) {
        idx = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
        thumbs.forEach(function (t, ti) {
          var on = ti === idx;
          t.classList.toggle('is-active', on);
          if (on) { try { t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {} }
        });
        if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
        gal.classList.toggle('lrc-lp-gal--dots-white', slides[idx] && slides[idx].getAttribute('data-dot-color') === 'white');
      }
      var prev = gal.querySelector('[data-lp-gal-prev]');
      var next = gal.querySelector('[data-lp-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-gal-dot'), 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-gal-thumb'), 10)); }); });
      gal.classList.toggle('lrc-lp-gal--dots-white', slides[0] && slides[0].getAttribute('data-dot-color') === 'white'); /* initial slide's palette */
      var x0 = null;
      var vp = gal.querySelector('[data-lp-gal-viewport]');
      vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
      go(0);
    })();

    /* ---------- Tabs (segmented control + sliding pill) ---------- */
    (function () {
      var tabsWrap = root.querySelector('[data-lp-tabs]');
      if (!tabsWrap) return;
      var btns = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-lp-tab]'));
      var panels = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-lp-tab-panel]'));
      var pill = tabsWrap.querySelector('[data-lp-seg-pill]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-lp-tab');
          btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { var on = p.getAttribute('data-lp-tab-panel') === i; p.classList.toggle('is-active', on); p.hidden = !on; });
          if (pill) { pill.style.transform = 'translateX(' + (parseInt(i, 10) * 100) + '%)'; }
        });
      });
    })();

    /* ---------- Judge.me reviews — count-up hero, bars, stagger, summary modal, mid-list CTA ---------- */
    (function () {
      var rv = root.querySelector('[data-lp-reviews]');
      if (!rv) return;
      var productId = rv.getAttribute('data-product-id');
      var INITIAL = parseInt(rv.getAttribute('data-initial'), 10) || 10;
      var STEP = parseInt(rv.getAttribute('data-step'), 10) || 5;
      var listEl = rv.querySelector('[data-lp-rv-list]');
      var moreWrap = rv.querySelector('[data-lp-rv-more-wrap]');
      var moreBtn = rv.querySelector('[data-lp-rv-more]');
      var numEl = rv.querySelector('[data-lp-rv-num]');
      var countNumEl = rv.querySelector('[data-lp-rv-count-num]');
      var heroEl = rv.querySelector('[data-lp-rv-hero]');
      var reduced = false; try { reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}
      var shown = 0, total = parseInt(rv.getAttribute('data-count'), 10) || 0, fetchTotal = 0, loading = false, ctaInserted = false; /* total = displayed count (liquid metafields); fetchTotal = API's list size, pagination only */
      var buffer = [], fetchedPages = 0, serverDone = false, PAGE_SIZE = 10;
      var targetRating = parseFloat(rv.getAttribute('data-rating')) || 0;

      function buildUrl(perPage, p) {
        var base = 'https://api.judge.me/reviews/';
        if (productId) {
          return base + 'reviews_for_widget?url=longruncoffee.myshopify.com&shop_domain=longruncoffee.myshopify.com&platform=shopify&product_id=' + productId + '&per_page=' + perPage + '&page=' + p;
        }
        /* no product id -> store-wide reviews via the all-reviews-page widget */
        return base + 'reviews_for_all_reviews_page?url=longruncoffee.myshopify.com&shop_domain=longruncoffee.myshopify.com&platform=shopify&per_page=' + perPage + '&page=' + p;
      }
      function parseReviews(html) {
        var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
        var out = [];
        doc.querySelectorAll('.jdgm-rev').forEach(function (el) {
          var rEl = el.querySelector('.jdgm-rev__rating');
          var score = rEl ? (parseFloat(rEl.dataset.score) || 5) : 5;
          var title = (el.querySelector('.jdgm-rev__title') || {}).textContent || '';
          var body = (el.querySelector('.jdgm-rev__body') || {}).textContent || '';
          var author = (el.querySelector('.jdgm-rev__author') || {}).textContent || 'Verified Buyer';
          var buyerBadge = el.querySelector('.jdgm-rev__buyer-badge');
          var verified = !!(buyerBadge && buyerBadge.textContent.trim().length);
          var dateEl = el.querySelector('.jdgm-rev__timestamp');
          var date = dateEl ? (dateEl.dataset.content || dateEl.textContent || '') : '';
          var photoEl = el.querySelector('.jdgm-rev__pic-img');
          var photo = photoEl ? (photoEl.dataset.src || photoEl.getAttribute('src') || '') : '';
          out.push({ score: score, title: title.trim(), body: body.trim(), author: author.trim(), verified: verified, date: date.trim(), photo: photo });
        });
        return out;
      }
      function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += (i <= Math.round(n) ? '★' : '☆'); return s; }
      function fmtDate(d) { if (!d) return ''; try { var dt = new Date(d.replace(' UTC', '').trim()); if (isNaN(dt.getTime())) return d; return dt.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }); } catch (e) { return d; } }

      /* staggered reveal */
      var revIO = ('IntersectionObserver' in window && !reduced) ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var el = en.target;
            setTimeout(function () { el.classList.add('lrc-rv-in'); }, parseInt(el.getAttribute('data-rv-d') || 0, 10));
            revIO.unobserve(el);
          }
        });
      }, { threshold: 0.12 }) : null;
      function observe(el, i) {
        if (!revIO) { el.classList.add('lrc-rv-in'); return; }
        el.setAttribute('data-rv-d', (i % 3) * 90);
        revIO.observe(el);
      }

      function build(r) {
        var el = document.createElement('div'); el.className = 'lrc-lp-rv-item';
        var date = r.date ? '<span class="lrc-lp-rv-item-date">' + fmtDate(r.date) + '</span>' : '';
        var photo = r.photo ? '<img class="lrc-lp-rv-item-photo" src="' + r.photo + '" loading="lazy" alt="Review photo">' : '';
        var footer = '<div class="lrc-lp-rv-item-foot"><span class="lrc-lp-rv-item-verified">✓ Verified Buyer</span></div>'; /* Judge.me widget HTML doesn't reliably carry the badge; all reviews are verified buyers */
        el.innerHTML = '<div class="lrc-lp-rv-item-head"><span class="lrc-lp-rv-item-stars">' + stars(r.score) + '</span><span class="lrc-lp-rv-item-author">' + r.author + '</span>' + date + '</div>' + (r.title ? '<p class="lrc-lp-rv-item-title">' + r.title + '</p>' : '') + (r.body ? '<p class="lrc-lp-rv-item-body">' + r.body + '</p>' : '') + photo + footer;
        return el;
      }

      /* skeleton shimmer */
      function skeleton(n) {
        listEl.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var sk = document.createElement('div'); sk.className = 'lrc-lp-rv-skel';
          sk.innerHTML = '<span style="width:40%"></span><span style="width:92%"></span><span style="width:78%"></span>';
          listEl.appendChild(sk);
        }
      }
      function clearSkeleton() {
        [].slice.call(listEl.querySelectorAll('.lrc-lp-rv-skel')).forEach(function (n) { n.remove(); });
      }

      /* mid-list CTA after review 6 */
      function maybeInsertCta() {
        if (ctaInserted) return;
        var tpl = rv.querySelector('[data-lp-rv-cta-template]');
        var items = listEl.querySelectorAll('.lrc-lp-rv-item');
        if (!tpl || items.length < 7) return;
        var cta = tpl.content.firstElementChild.cloneNode(true);
        var btn = cta.querySelector('[data-lp-rv-cta-btn]');
        if (btn) btn.addEventListener('click', function () {
          var picker = document.querySelector('[data-lp-picker]');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        items[5].parentNode.insertBefore(cta, items[5].nextSibling);
        observe(cta, 0);
        ctaInserted = true;
      }

      function appendFromBuffer(n) {
        var batch = buffer.splice(0, n);
        batch.forEach(function (r, i) { var el = build(r); listEl.appendChild(el); observe(el, i); });
        shown += batch.length;
        maybeInsertCta();
        if (moreWrap) moreWrap.hidden = !((total && shown < total) || buffer.length > 0 || !serverDone);
      }
      /* fetch pages of PAGE_SIZE into the buffer until it can serve n more items */
      function ensure(n, isFirst, doneCb) {
        if (buffer.length >= n || serverDone) { doneCb(); return; }
        if (loading) return; loading = true; if (moreBtn) moreBtn.disabled = true;
        fetch(buildUrl(PAGE_SIZE, fetchedPages + 1), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (data) {
            loading = false; if (moreBtn) moreBtn.disabled = false;
            fetchedPages++;
            if (data.total_count) { fetchTotal = data.total_count; if (!total) { total = data.total_count; queueCountUp(); } } /* API total drives pagination; it only backstops the display when liquid gave no count */
            var reviews = parseReviews(data.html || '');
            if (reviews.length < PAGE_SIZE) serverDone = true;
            buffer = buffer.concat(reviews);
            if (fetchedPages * PAGE_SIZE >= (fetchTotal || total) && (fetchTotal || total)) serverDone = true;
            ensure(n, isFirst, doneCb);
          })
          .catch(function (err) {
            loading = false; console.warn('[lrc-lp-caffyne reviews]', err);
            serverDone = true;
            if (isFirst && !buffer.length) { clearSkeleton(); listEl.innerHTML = '<div class="lrc-lp-rv-empty">' + LRC.reviewsError + '</div>'; if (moreWrap) moreWrap.hidden = true; }
            else { doneCb(); }
            if (moreBtn) moreBtn.disabled = false;
          });
      }
      function show(n, isFirst) {
        ensure(n, isFirst, function () {
          if (isFirst) {
            clearSkeleton();
            if (!buffer.length) { listEl.innerHTML = '<div class="lrc-lp-rv-empty">' + LRC.reviewsEmpty + '</div>'; if (moreWrap) moreWrap.hidden = true; return; }
          }
          appendFromBuffer(n);
        });
      }
      if (moreBtn) moreBtn.addEventListener('click', function () { show(STEP, false); });

      /* count-up + bar fill when the hero enters the viewport */
      var counted = false, heroVisible = false;
      function runCountUp() {
        if (counted || !heroVisible || !(targetRating || total)) return;
        counted = true;
        if (reduced) {
          if (numEl) numEl.textContent = targetRating ? targetRating.toFixed(1) : '';
          if (countNumEl) countNumEl.textContent = total.toLocaleString();
        } else {
          var t0 = performance.now();
          (function tick(t) {
            var p = Math.min(1, (t - t0) / 900);
            var e = 1 - Math.pow(1 - p, 3);
            if (numEl && targetRating) numEl.textContent = (targetRating * e).toFixed(1);
            if (countNumEl && total) countNumEl.textContent = Math.round(total * e).toLocaleString();
            if (p < 1) requestAnimationFrame(tick);
          })(t0);
        }
        /* backstop: sync the fractional star overlay to the count-up rating */
        var starFill = rv.querySelector('[data-lp-rv-starfill]');
        if (starFill && targetRating) starFill.style.width = (targetRating / 5 * 100) + '%';
        [].slice.call(rv.querySelectorAll('[data-lp-rv-bar]')).forEach(function (b) {
          var count = parseInt(b.getAttribute('data-bcount'), 10) || 0;
          var btotal = parseInt(b.getAttribute('data-btotal'), 10) || 1;
          var pct = count > 0 ? Math.max(2, Math.round(count / btotal * 100)) : 0;
          b.style.width = pct + '%';
        });
      }
      function queueCountUp() { runCountUp(); }
      if (heroEl && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en, obs) {
          for (var k = 0; k < en.length; k++) {
            if (en[k].isIntersecting) { heroVisible = true; runCountUp(); obs.disconnect(); }
          }
        }, { threshold: 0.4 }).observe(heroEl);
      } else { heroVisible = true; }

      /* summary modal — portaled sheet (mobile) / popup (desktop) */
      var sumBtn = rv.querySelector('[data-lp-rv-sumbtn]');
      var sumTpl = rv.querySelector('[data-lp-rv-sum-template]');
      var sumOv = null, prevOF = null;
      function lockScroll() { prevOF = [document.documentElement.style.overflow, document.body.style.overflow]; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
      function unlockScroll() { document.documentElement.style.overflow = prevOF ? prevOF[0] : ''; document.body.style.overflow = prevOF ? prevOF[1] : ''; }
      function closeSum() { if (sumOv) { sumOv.classList.remove('is-open'); unlockScroll(); } }
      if (sumBtn && sumTpl) {
        sumBtn.addEventListener('click', function () {
          if (!sumOv) {
            sumOv = document.createElement('div');
            sumOv.className = 'lrc-lp-root lrc-lp-rv-ov';
            sumOv.appendChild(sumTpl.content.firstElementChild.cloneNode(true));
            document.body.appendChild(sumOv);
            sumOv.addEventListener('click', function (e) { if (e.target === sumOv) closeSum(); });
            var x = sumOv.querySelector('[data-lp-rv-sum-x]');
            if (x) x.addEventListener('click', closeSum);
            var sumCta = sumOv.querySelector('[data-lp-rv-sum-cta]');
            if (sumCta) sumCta.addEventListener('click', function () {
              closeSum();
              var picker = document.querySelector('[data-lp-picker]');
              if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSum(); });
          }
          lockScroll();
          requestAnimationFrame(function () { sumOv.classList.add('is-open'); });
          sumOv.style.display = '';
        });
      }


      /* hero review row -> same summary sheet (falls back to scrolling to reviews) */
      var heroTrig = document.querySelector('[data-lp-hero-reviews]');
      if (heroTrig) heroTrig.addEventListener('click', function () {
        if (sumBtn) { sumBtn.click(); }
        else { rv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });

      skeleton(3);
      show(INITIAL, true);
    })();
  })();

  /* ---------- Waypoints entrance — one-time reveal via IntersectionObserver ---------- */
  (function () {
    var wp = document.querySelector('.lrc-lp-root [data-lp-waypoints]');
    if (!wp) return;
    var reveal = function () { wp.classList.add('in'); };
    var prefersRM = false; try { prefersRM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}
    if (prefersRM || !('IntersectionObserver' in window)) { reveal(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { reveal(); io.disconnect(); }
      });
    }, { threshold: 0.25 });
    io.observe(wp);
  })();

  /* ---------- Gear Drop shipping countdown — HH:MM:SS digits, 1s tick, weekend guard, never NaN ---------- */
  (function () {
    var el = document.querySelector('.lrc-lp-root [data-lp-ship-countdown]');
    if (!el) return;
    var labelEl = el.querySelector('[data-lp-count-label]');
    var digitsEl = el.querySelector('[data-lp-count-digits]');
    var dEl = el.querySelector('[data-d]'), hEl = el.querySelector('[data-h]'), mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
    var dSlot = el.querySelector('[data-slot-d]'), dColon = el.querySelector('[data-colon-d]');
    var packHour = parseInt(el.getAttribute('data-pack-hour'), 10); if (isNaN(packHour)) { packHour = 5; }
    var tz = el.getAttribute('data-tz') || 'America/Chicago';
    var labWeekday = el.getAttribute('data-label-weekday') || 'Order now — ships in under 24 hours';
    var labWeekend = el.getAttribute('data-label-weekend') || 'Order now — ships Monday morning';
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function accent(txt) { var i = txt.indexOf('ships '); return i < 0 ? txt : (txt.slice(0, i + 6) + '<span class="lrc-lp-gd-count-hl">' + txt.slice(i + 6) + '</span>'); }
    function tick() {
      try {
        var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false });
        var parts = {}; f.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
        var wdMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        var wd = wdMap[parts.weekday], hh = parseInt(parts.hour, 10) % 24, mm = parseInt(parts.minute, 10), ss = parseInt(parts.second, 10);
        if (wd === undefined || isNaN(hh) || isNaN(mm) || isNaN(ss)) { throw new Error('parse'); }
        var nowSec = hh * 3600 + mm * 60 + ss, packSec = packHour * 3600, found = -1;
        for (var i = 0; i < 8; i++) {
          var d = (wd + i) % 7;
          if (d >= 1 && d <= 5) { if (i === 0 && packSec <= nowSec) { continue; } found = i; break; }
        }
        if (found < 0) { throw new Error('noday'); }
        var total = found * 86400 + (packSec - nowSec);
        if (isNaN(total) || total < 0) { throw new Error('nan'); }
        if (labelEl) { labelEl.innerHTML = accent(total > 86400 ? labWeekend : labWeekday); }
        var days = Math.floor(total / 86400), rem = total % 86400, showDays = total >= 86400;
        if (dSlot) { dSlot.hidden = !showDays; }
        if (dColon) { dColon.hidden = !showDays; }
        if (showDays && dEl) { dEl.textContent = pad(days); }
        if (hEl) { hEl.textContent = pad(Math.floor(rem / 3600)); }
        if (mEl) { mEl.textContent = pad(Math.floor((rem % 3600) / 60)); }
        if (sEl) { sEl.textContent = pad(rem % 60); }
        if (digitsEl) { digitsEl.style.display = ''; }
      } catch (e) {
        if (labelEl) { labelEl.textContent = 'Ships next business day'; }
        if (digitsEl) { digitsEl.style.display = 'none'; }
      }
    }
    tick();
    setInterval(tick, 1000);
  })();

/* ── Athletes carousel (desktop 4-up; controls self-hide at <=4 cards) ── */
(function () {
  var sec = document.querySelector('.lrc-lp-athletes');
  if (!sec) return;
  var track = sec.querySelector('[data-lp-ath-track]');
  var prev = sec.querySelector('[data-lp-ath-prev]');
  var next = sec.querySelector('[data-lp-ath-next]');
  var dotsWrap = sec.querySelector('[data-lp-ath-dots]');
  if (!track || !prev || !next || !dotsWrap) return;
  var cards = track.querySelectorAll('.lrc-lp-ath-card');
  if (cards.length <= 4) { sec.classList.add('lrc-ath-static'); return; }

  var dots = [];
  for (var i = 0; i < cards.length; i++) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'lrc-lp-ath-dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('data-idx', i);
    d.addEventListener('click', function () {
      var idx = parseInt(this.getAttribute('data-idx'), 10);
      track.scrollTo({ left: step() * idx, behavior: 'smooth' });
    });
    dotsWrap.appendChild(d);
    dots.push(d);
  }

  function step() {
    var gap = 18;
    return cards[0].getBoundingClientRect().width + gap;
  }
  function setActive() {
    var idx = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / step())));
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === idx);
  }
  prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  var t;
  track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(setActive, 80); }, { passive: true });
})();


/* ── Format explainer: 60-minute dial — scroll-scrubbed + draggable head ── */
(function () {
  var sec = document.querySelector('[data-lp-fmtdial]');
  if (!sec) return;
  var fill = sec.querySelector('[data-lp-fmt-fill]');
  var timeEl = sec.querySelector('[data-lp-fmt-time]');
  var labelEl = sec.querySelector('[data-lp-fmt-label]');
  var pouch = sec.querySelector('[data-lp-fmt-pouch]');
  var dialwrap = sec.querySelector('.lrc-lp-fmt-dialwrap');
  var chips = sec.querySelectorAll('.lrc-lp-fmt-chip');
  if (!fill || !timeEl || !dialwrap) return;
  var C = 565.49;
  var TOTAL = parseFloat(sec.getAttribute('data-dial-total')) || 3600; /* seconds */
  var KICK = Math.min(0.25, 300 / TOTAL); /* kick-in point: 5min on the classic dial, proportional cap on short dials */
  var LABS = {
    start: sec.getAttribute('data-lab-start') || 'TUCK IT IN',
    kick: sec.getAttribute('data-lab-kick') || 'KICKING IN',
    flow: sec.getAttribute('data-lab-flow') || 'ENERGY FLOWING',
    enjoy: sec.getAttribute('data-lab-enjoy') || 'ENJOY THE FLAVOR',
    done: sec.getAttribute('data-lab-done') || 'TOSS IT — KEEP MOVING'
  };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var thresholds = [0.02, KICK, 0.92];

  function render(p) {
    fill.style.strokeDashoffset = C * (1 - p);
    var secs = p * TOTAL, m = Math.floor(secs / 60), sN = Math.floor(secs % 60);
    timeEl.textContent = m + ':' + (sN < 10 ? '0' : '') + sN;
    if (labelEl) {
      labelEl.textContent = p < 0.005 ? LABS.start
        : (p < KICK ? LABS.kick
        : (p < 0.5 ? LABS.flow
        : (p < 0.97 ? LABS.enjoy : LABS.done)));
    }
    if (pouch) {
      // ride the front of the fill around the arc (r=90 of 220 viewBox)
      var w = dialwrap.clientWidth;
      var cx = w / 2, r = w * (90 / 220);
      var a = -Math.PI / 2 + p * Math.PI * 2;
      pouch.style.left = (cx + r * Math.cos(a)) + 'px';
      pouch.style.top = (cx + r * Math.sin(a)) + 'px';
      pouch.style.opacity = Math.max(0.5, 1 - p * 0.6);
      pouch.style.transform = 'translate(-50%,-50%) scale(' + (1 - p * 0.25) + ') rotate(' + (p * 360) + 'deg)';
    }
    for (var k = 0; k < chips.length; k++) {
      chips[k].classList.toggle('is-on', p >= (thresholds[k] !== undefined ? thresholds[k] : 0.5));
    }
    sec.classList.toggle('is-done', p >= 0.98);
    // (location chips animate via their own viewport observer, not is-done)
  }

  if (reduced) { render(1); return; }

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function scrollP() {
    var rect = dialwrap.getBoundingClientRect();
    var vh = window.innerHeight;
    // starts when the dial's TOP crosses ~60% down the viewport (0:00 readable first);
    // completes as its top reaches ~14% — slower scrub, dial fully visible throughout
    return clamp((vh * 0.60 - rect.top) / (vh * 0.46), 0, 1);
  }
  var dragging = false;
  function onScroll() { if (!dragging) render(scrollP()); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  var placesRow = sec.querySelector('[data-lp-fmt-places]');
  if (placesRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { placesRow.classList.add('is-in'); obs.disconnect(); }
      }
    }, { threshold: 0.4 }).observe(placesRow);
  } else if (placesRow) { placesRow.classList.add('is-in'); }

  if (pouch && window.PointerEvent) {
    pouch.addEventListener('pointerdown', function (e) {
      dragging = true;
      pouch.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    pouch.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var rect = dialwrap.getBoundingClientRect();
      var cx = rect.left + rect.width / 2, cy = rect.top + rect.width / 2;
      var ang = Math.atan2(e.clientY - cy, e.clientX - cx) + Math.PI / 2;
      if (ang < 0) ang += Math.PI * 2;
      render(clamp(ang / (Math.PI * 2), 0, 1));
    });
    var end = function () { dragging = false; };
    pouch.addEventListener('pointerup', end);
    pouch.addEventListener('pointercancel', end);
  }
})();


/* ── UGC: one-at-a-time autoplay rail + fullscreen TikTok-style feed ── */
(function () {
  var sec = document.querySelector('[data-lp-ugc]');
  if (!sec) return;
  var rail = sec.querySelector('[data-lp-ugc-rail]');
  var cards = [].slice.call(sec.querySelectorAll('[data-lp-ugc-card]'));
  if (!rail || !cards.length) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var deskMQ = window.matchMedia('(min-width: 960px)');
  var railInView = false, hovered = null, activeIdx = 0, overlayOpen = false;

  var ICON_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="#F4F1EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5z" fill="#F4F1EA" stroke="none"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18 6a8.5 8.5 0 0 1 0 12"/></svg>';
  var ICON_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="#F4F1EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5z" fill="#F4F1EA" stroke="none"/><line x1="16" y1="9" x2="22" y2="15"/><line x1="22" y1="9" x2="16" y2="15"/></svg>';

  /* ── single playback governor ── */
  function safePlay(v) {
    if (v._want === 1) return;
    v._want = 1;
    var p = v.play();
    if (p && p.then) {
      v._pp = p;
      p.then(function () { v._pp = null; if (v._want === 0) v.pause(); })
       .catch(function () { v._pp = null; });
    }
  }
  function safePause(v) {
    if (v._want === 0) return;
    v._want = 0;
    if (v._pp) { /* play() still settling — the then() above will pause */ }
    else { v.pause(); }
  }
  var syncT;
  function sync() {
    clearTimeout(syncT);
    syncT = setTimeout(function () {
      cards.forEach(function (c, i) {
        var v = c.querySelector('video');
        if (!v) return;
        var should = false;
        if (!overlayOpen && railInView && !reduced) {
          should = deskMQ.matches ? (hovered ? hovered === c : i === activeIdx) : (i === activeIdx);
        }
        if (should) safePlay(v); else safePause(v);
      });
    }, 60);
  }
  /* desktop: buffer ahead so hover-play starts instantly */
  function bumpPreload() {
    if (deskMQ.matches) cards.forEach(function (c) {
      var v = c.querySelector('video');
      if (v && v.preload !== 'auto') v.preload = 'auto';
    });
  }
  bumpPreload();
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      railInView = en[0].isIntersecting; sync();
    }, { threshold: 0.25 }).observe(rail);
  } else { railInView = true; }

  cards.forEach(function (c) {
    c.addEventListener('mouseenter', function () { if (deskMQ.matches) { hovered = c; sync(); } });
    c.addEventListener('mouseleave', function () { if (hovered === c) { hovered = null; sync(); } });
  });
  if (deskMQ.addEventListener) deskMQ.addEventListener('change', function () { bumpPreload(); sync(); });

  function setActive() {
    var mid = rail.scrollLeft + rail.clientWidth / 2;
    var best = 0, bd = 1e9;
    cards.forEach(function (c, i) {
      var cm = c.offsetLeft + c.offsetWidth / 2, d = Math.abs(cm - mid);
      if (d < bd) { bd = d; best = i; }
    });
    activeIdx = best;
    cards.forEach(function (c, i) { c.classList.toggle('is-active', i === best); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
    sync();
  }
  var st; rail.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(setActive, 80); }, { passive: true });

  cards.forEach(function (c, ci) {
    var v = c.querySelector('video'), bar = c.querySelector('[data-lp-ugc-prog]');
    var lastT = 0;
    if (v) v.addEventListener('timeupdate', function () {
      if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%';
      // desktop idle auto-advance: loop wrap on the active, unhovered card => next video
      if (deskMQ.matches && !hovered && !overlayOpen && ci === activeIdx && v.currentTime < lastT - 0.5 && cards.length > 1) {
        var nx = (activeIdx + 1) % cards.length;
        rail.scrollTo({ left: (cards[0].getBoundingClientRect().width + 12) * nx, behavior: 'smooth' });
      }
      lastT = v.currentTime;
    });
  });

  /* ── desktop carousel controls (arrows + dots; only when scrollable) ── */
  var prev = sec.querySelector('[data-lp-ugc-prev]');
  var next = sec.querySelector('[data-lp-ugc-next]');
  var dotsWrap = sec.querySelector('[data-lp-ugc-dots]');
  var dots = [];
  if (cards.length > 4) sec.classList.add('has-carousel');
  if (cards.length > 1) sec.classList.add('has-dots');
  function step() { return cards[0].getBoundingClientRect().width + 12; }
  if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  if (dotsWrap) {
    cards.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'lrc-lp-ugc-dot' + (i === 0 ? ' is-active' : '');
      d.addEventListener('click', function () { rail.scrollTo({ left: step() * i, behavior: 'smooth' }); });
      dotsWrap.appendChild(d); dots.push(d);
    });
  }
  setActive();

  /* ── fullscreen feed overlay (portaled to body) ── */
  var ov = null, feed = null, ovVideos = [], soundOn = true, prevOverflow = null, coachShown = false;
  var ctaTpl = sec.querySelector('[data-lp-ugc-cta-template]');

  function lockScroll() {
    prevOverflow = [document.documentElement.style.overflow, document.body.style.overflow];
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    document.documentElement.style.overflow = prevOverflow ? prevOverflow[0] : '';
    document.body.style.overflow = prevOverflow ? prevOverflow[1] : '';
  }
  function buildOverlay() {
    ov = document.createElement('div');
    ov.className = 'lrc-lp-root lrc-lp-ugc-ov';
    feed = document.createElement('div');
    feed.className = 'lrc-lp-ugc-feed';
    cards.forEach(function (c) {
      var slide = document.createElement('div');
      slide.className = 'lrc-lp-ugc-slide';
      var v = document.createElement('video');
      v.src = c.getAttribute('data-video-src');
      v.setAttribute('playsinline', ''); v.loop = true; v.preload = 'metadata';
      slide.appendChild(v);
      var scrim = document.createElement('div');
      scrim.className = 'lrc-lp-ugc-ovscrim';
      var nm = c.getAttribute('data-name');
      scrim.innerHTML = (nm ? '<div class="lrc-lp-ugc-ovname">' + nm + '</div>' : '');
      if (ctaTpl) {
        var cta = ctaTpl.content.firstElementChild.cloneNode(true);
        cta.addEventListener('click', function () {
          closeOverlay();
          var picker = document.querySelector('[data-lp-picker]');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        scrim.appendChild(cta);
      }
      slide.appendChild(scrim);
      ovVideos.push(v);
      feed.appendChild(slide);
    });
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'lrc-lp-ugc-x'; x.innerHTML = '\u2715'; x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', closeOverlay);
    var mute = document.createElement('button');
    mute.type = 'button'; mute.className = 'lrc-lp-ugc-mute'; mute.setAttribute('aria-label', 'Toggle sound');
    function muteIcon() { mute.innerHTML = soundOn ? ICON_ON : ICON_OFF; }
    mute.addEventListener('click', function () {
      soundOn = !soundOn; muteIcon();
      ovVideos.forEach(function (v) { v.muted = !soundOn; });
    });
    muteIcon();
    var nav = document.createElement('div');
    nav.className = 'lrc-lp-ugc-nav';
    var up = document.createElement('button');
    up.type = 'button'; up.setAttribute('aria-label', 'Previous video');
    up.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#F4F1EA" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg>';
    up.addEventListener('click', function () { feed.scrollBy({ top: -feed.clientHeight, behavior: 'smooth' }); });
    var down = document.createElement('button');
    down.type = 'button'; down.setAttribute('aria-label', 'Next video');
    down.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#F4F1EA" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
    down.addEventListener('click', function () { feed.scrollBy({ top: feed.clientHeight, behavior: 'smooth' }); });
    nav.appendChild(up); nav.appendChild(down);
    ov.appendChild(feed); ov.appendChild(x); ov.appendChild(mute); ov.appendChild(nav);
    document.body.appendChild(ov);
    var ft; feed.addEventListener('scroll', function () {
      var coach = ov.querySelector('.lrc-lp-ugc-coach');
      if (coach) coach.remove();
      clearTimeout(ft); ft = setTimeout(playCurrent, 90);
    }, { passive: true });
    document.addEventListener('keydown', escClose);
  }
  function escClose(e) { if (e.key === 'Escape' && ov && ov.style.display !== 'none') closeOverlay(); }
  function playCurrent() {
    if (!feed) return;
    var idx = Math.round(feed.scrollTop / feed.clientHeight);
    ovVideos.forEach(function (v, i) {
      if (i === idx) {
        v.muted = !soundOn;
        v.play().catch(function () { v.muted = true; soundOn = false; v.play().catch(function () {}); });
      } else { v.pause(); }
    });
  }
  function showCoach() {
    if (coachShown || cards.length < 2) return;
    coachShown = true;
    var coach = document.createElement('div');
    coach.className = 'lrc-lp-ugc-coach';
    coach.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11V4.5a1.5 1.5 0 0 1 3 0V10m0-1.5a1.5 1.5 0 0 1 3 0V10m0 .5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-1a6 6 0 0 1-5.2-3L4 14.5a1.6 1.6 0 0 1 2.6-1.8L9 15"/><path d="M12 2.5V1"/></svg>';
    ov.appendChild(coach);
    setTimeout(function () { if (coach.parentNode) coach.remove(); }, 4600);
  }
  function openOverlay(idx) {
    if (!ov) buildOverlay(); else ov.style.display = '';
    overlayOpen = true;
    lockScroll();
    sync();
    feed.scrollTop = feed.clientHeight * idx;
    requestAnimationFrame(playCurrent);
    showCoach();
  }
  function closeOverlay() {
    if (!ov) return;
    ov.style.display = 'none';
    overlayOpen = false;
    ovVideos.forEach(function (v) { v.pause(); });
    unlockScroll();
    setActive();
  }
  cards.forEach(function (c, i) { c.addEventListener('click', function () { openOverlay(i); }); });
})();


/* ── Testimonial wall: JS marquee (seamless loop, hover pause, click-drag) ── */
(function () {
  var rows = document.querySelectorAll('[data-lp-wall-row]');
  if (!rows.length) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return; /* static scrollable rail */

  rows.forEach(function (row) {
    /* duplicate once for the seamless wrap */
    row.insertAdjacentHTML('beforeend', row.innerHTML.replace(/<figure /g, '<figure aria-hidden="true" '));

    var dir = row.getAttribute('data-lp-wall-row') === 'b' ? 1 : -1;
    var half = 0, pos = 0, hovered = false, dragging = false, startX = 0, startPos = 0, DUR = dir === 1 ? 64 : 56; /* seconds per half-loop — slightly slower than v1 */

    function measure() { half = row.scrollWidth / 2; if (dir === 1 && pos === 0) pos = -half; }
    measure();
    window.addEventListener('resize', measure, { passive: true });

    function wrap(p) {
      if (half <= 0) return p;
      while (p <= -half) p += half;
      while (p > 0) p -= half;
      return p;
    }
    var last = null;
    function tick(t) {
      if (last === null) last = t;
      var dt = (t - last) / 1000; last = t;
      if (!hovered && !dragging && half > 0) {
        pos = wrap(pos + dir * (half / DUR) * dt);
        row.style.transform = 'translateX(' + pos + 'px)';
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    var wrapEl = row.parentNode;
    wrapEl.addEventListener('mouseenter', function () { hovered = true; });
    wrapEl.addEventListener('mouseleave', function () { hovered = false; });

    if (window.PointerEvent) {
      wrapEl.addEventListener('pointerdown', function (e) {
        dragging = true; startX = e.clientX; startPos = pos;
        wrapEl.setPointerCapture(e.pointerId);
        e.preventDefault(); /* stop text-selection/native drag from starting */
      });
      wrapEl.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        pos = wrap(startPos + (e.clientX - startX));
        row.style.transform = 'translateX(' + pos + 'px)';
      });
      var end = function () { dragging = false; };
      wrapEl.addEventListener('pointerup', end);
      wrapEl.addEventListener('pointercancel', end);
    }
  });
})();


/* ── Ingredient spotlight: 5s auto-cycle, image crossfade, gliding connector ── */
(function () {
  var sec = document.querySelector('[data-lp-ings]');
  if (!sec) return;
  var stage = sec.querySelector('[data-lp-ings-stage]');
  var imgsWrap = sec.querySelector('[data-lp-ings-imgs]');
  var conn = sec.querySelector('[data-lp-ings-conn]');
  var cardsWrap = sec.querySelector('[data-lp-ings-cards]');
  var imgs = [].slice.call(sec.querySelectorAll('.lrc-lp-ings2-img'));
  var cards = [].slice.call(sec.querySelectorAll('.lrc-lp-ings2-card'));
  if (!cards.length) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var deskMQ = window.matchMedia('(min-width: 960px)');
  var cur = 0, timer = null, started = false;

  function place() {
    if (!conn) return;
    var c = cards[cur];
    var midY = cardsWrap.offsetTop + c.offsetTop + c.offsetHeight / 2;
    if (deskMQ.matches) {
      conn.style.left = imgsWrap.offsetWidth + 'px';
      conn.style.top = midY + 'px';
      conn.style.width = '44px';
      conn.style.height = '2px';
    } else {
      var t0 = imgsWrap.offsetTop + imgsWrap.offsetHeight;
      conn.style.left = '10px';
      conn.style.width = '2px';
      conn.style.top = t0 + 'px';
      conn.style.height = Math.max(0, midY - t0) + 'px';
    }
  }
  function activate(i, manual) {
    cur = i;
    imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
    cards.forEach(function (c, k) {
      c.classList.toggle('is-on', k === i);
      var bar = c.querySelector('.lrc-lp-ings2-bar i');
      if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
    });
    place();
    clearTimeout(timer);
    if (!reduced) timer = setTimeout(function () { activate((cur + 1) % cards.length); }, 5000);
  }
  cards.forEach(function (c, i) { c.addEventListener('click', function () { activate(i, true); }); });
  window.addEventListener('resize', place, { passive: true });
  if (deskMQ.addEventListener) deskMQ.addEventListener('change', place);

  /* start cycling only when the stage enters the viewport */
  if ('IntersectionObserver' in window && !reduced) {
    new IntersectionObserver(function (en, obs) {
      for (var k = 0; k < en.length; k++) {
        if (en[k].isIntersecting && !started) { started = true; activate(0); obs.disconnect(); }
      }
    }, { threshold: 0.3 }).observe(stage);
    place();
  } else {
    activate(0);
  }
})();


/* ── Versus: mobile competitor switcher ── */
(function () {
  var sec = document.querySelector('[data-lp-vs]');
  if (!sec) return;
  var pills = [].slice.call(sec.querySelectorAll('[data-lp-vs-pill]'));
  var cardsWrap = sec.querySelector('[data-lp-vs-them]');
  if (!pills.length || !cardsWrap) return;
  var cards = [].slice.call(cardsWrap.querySelectorAll('[data-lp-vs-themcard]'));
  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      var idx = p.getAttribute('data-lp-vs-pill');
      pills.forEach(function (x) { x.classList.toggle('is-on', x === p); });
      cards.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-lp-vs-themcard') === idx); });
    });
  });
})();


/* ── FAQ: accordion cards + mobile see-more ── */
(function () {
  var sec = document.querySelector('[data-lp-faq]');
  if (!sec) return;
  var items = [].slice.call(sec.querySelectorAll('[data-lp-faq-item]'));
  items.forEach(function (item) {
    var q = item.querySelector('[data-lp-faq-q]');
    if (!q) return;
    q.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  var more = sec.querySelector('[data-lp-faq-more]');
  if (more) more.addEventListener('click', function () {
    var expanded = sec.classList.toggle('is-expanded');
    more.textContent = expanded ? (more.getAttribute('data-fewer-label') || 'Show fewer') : (more.getAttribute('data-more-label') || 'See all questions');
    if (!expanded) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  /* hide see-more when 3 or fewer questions */
  if (more && items.length <= 3) more.style.display = 'none';
})();


/* ── Footer last-chance CTA: back to the picker ── */
(function () {
  var btn = document.querySelector('[data-lp-footer-cta]');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var picker = document.querySelector('[data-lp-picker]');
    if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();


/* ── Sticky mini-cart: scroll-gated reveal + slide-up contents sheet ── */
(function () {
  var root = document.querySelector('.lrc-lp-root');
  if (!root) return;
  var bar = root.querySelector('[data-lp-sticky]');
  var picker = root.querySelector('[data-lp-picker]');
  if (!bar || !picker) return;
  var stickyCta = bar.querySelector('[data-lp-sticky-cta]');
  if (stickyCta) {
    var lbl0 = stickyCta.querySelector('.lrc-lp-cta-label');
    if (lbl0) stickyCta.setAttribute('data-idle-label', lbl0.textContent);
  }

  /* visibility: show only once the picker's own CTA is above the viewport */
  var mainCta = picker.querySelector('[data-lp-cta]');
  var gateEl = mainCta || picker;
  function vis() {
    var r = gateEl.getBoundingClientRect();
    bar.classList.toggle('is-shown', r.bottom < 0);
  }
  window.addEventListener('scroll', vis, { passive: true });
  window.addEventListener('resize', vis, { passive: true });
  vis();

  /* mini-cart sheet */
  var tpl = root.querySelector('[data-lp-minicart-template]');
  var slotsBtn = bar.querySelector('[data-lp-sticky-slots]');
  if (!tpl || !slotsBtn) return;
  var ov = null, prevOF = null;
  var freeShip = (parseFloat(root.getAttribute('data-free-ship')) || 0) * 100; /* cents, matching the money module */
  var freeShipAlways = root.getAttribute('data-free-ship-always') === 'true';

  function lock() { prevOF = [document.documentElement.style.overflow, document.body.style.overflow]; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
  function unlock() { document.documentElement.style.overflow = prevOF ? prevOF[0] : ''; document.body.style.overflow = prevOF ? prevOF[1] : ''; }
  function close() { if (ov) { ov.classList.remove('is-open'); unlock(); } }

  function fillSheet() {
    var lines = ov.querySelector('[data-lp-mc-lines]');
    if (!lines) return;
    var subC = 0, oneC = 0, hx = '', any = false;
    var vertEls = [].slice.call(root.querySelectorAll('[data-lp-vertical]'));
    if (vertEls.length) {
      var cells = '';
      vertEls.forEach(function (vEl) {
        var vcol = vEl.getAttribute('data-vcolor') || '#223F4E';
        [].slice.call(vEl.querySelectorAll('[data-flavor-variant]')).forEach(function (f) {
          var qEl = f.querySelector('[data-lp-qty]');
          var n = qEl ? (parseInt(qEl.textContent, 10) || 0) : 0;
          if (!n) return;
          any = true;
          subC += n * (parseInt(f.getAttribute('data-sub'), 10) || 0);
          oneC += n * (parseInt(f.getAttribute('data-otp'), 10) || 0);
          var nameEl = f.querySelector('.lrc-lp-flavor-label');
          var img = f.querySelector('.lrc-lp-flavor-img img');
          cells += '<div class="lrc-lp-mc-cell"><span class="lrc-lp-mc-cell-sw"' + (img ? ' style="background-image:url(\'' + img.getAttribute('src') + '\')"' : '') + '><span class="lrc-lp-mc-cell-qty">&times;' + n + '</span></span><span class="lrc-lp-mc-cell-name"><span class="lrc-lp-mc-cell-dot" style="background:' + vcol + '"></span>' + (nameEl ? nameEl.textContent : 'Item') + '</span></div>';
        });
      });
      if (cells) { hx = '<div class="lrc-lp-mc-items">' + cells + '</div>'; } /* one unified grid — no label rows, vertical shown as a color dot */
      lines.innerHTML = any ? hx : '<div class="lrc-lp-mc-line"><b class="lrc-lp-mc-empty">' + (lines.getAttribute('data-empty-label') || 'Nothing yet! Choose your items') + '</b></div>';
      finishSheet(subC, oneC);
      return;
    }
    [].slice.call(root.querySelectorAll('[data-flavor-variant]')).forEach(function (f) {
      var qEl = f.querySelector('[data-lp-qty]');
      var n = qEl ? (parseInt(qEl.textContent, 10) || 0) : 0;
      if (!n) return;
      any = true;
      subC += n * (parseInt(f.getAttribute('data-sub'), 10) || 0);
      oneC += n * (parseInt(f.getAttribute('data-otp'), 10) || 0);
      var nameEl = f.querySelector('.lrc-lp-flavor-label');
      var img = f.querySelector('.lrc-lp-flavor-img img');
      hx += '<div class="lrc-lp-mc-line">' + (img ? '<span class="lrc-lp-mc-swatch" style="background-image:url(\'' + img.getAttribute('src') + '\')"></span>' : '') + '<b>' + (nameEl ? nameEl.textContent : 'Flavor') + '</b><span>&times;' + n + '</span></div>';
    });
    lines.innerHTML = any ? hx : '<div class="lrc-lp-mc-line"><b class="lrc-lp-mc-empty">' + (lines.getAttribute('data-empty-label') || 'Nothing yet! Choose your flavors') + '</b></div>';
    finishSheet(subC, oneC);
  }
  function finishSheet(subC, oneC) {
    /* free-shipping row state */
    var shipRow = ov.querySelector('[data-lp-mc-ship]');
    if (shipRow) {
      var unlocked = freeShipAlways || (freeShip > 0 && subC >= freeShip);
      shipRow.classList.toggle('is-unlocked', unlocked);
      var mark = shipRow.querySelector('[data-lp-mc-ship-mark]');
      if (mark) mark.innerHTML = unlocked ? '&#10003;' : '&#9675;';
      var at = shipRow.querySelector('[data-lp-mc-ship-at]');
      if (at) {
        if (unlocked) { at.innerHTML = '<s>' + (shipRow.getAttribute('data-ship-value') || '$7.99') + '</s>'; }
        else { at.textContent = 'at $' + Math.round(freeShip / 100); }
      }
    }
    /* sheet CTA mirrors the sticky CTA's current label + state */
    var mcCta = ov.querySelector('[data-lp-mc-cta]');
    var srcLbl = stickyCta && stickyCta.querySelector('.lrc-lp-cta-label');
    if (mcCta && srcLbl) {
      var giftCents = parseInt(root.getAttribute('data-gift-cents'), 10) || 0;
      var wasC = (oneC || 0) + giftCents;
      var lblTxt = srcLbl.textContent;
      var isMet = stickyCta.classList.contains('is-ready');
      if (isMet && wasC > subC && lblTxt.indexOf('→') > -1) {
        var pieces = lblTxt.split('→');
        var esc = function (t) { return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
        mcCta.innerHTML = esc(pieces[0]) + '→ <s>$' + (wasC / 100).toFixed(2) + '</s> ' + esc(pieces.slice(1).join('→').trim());
      } else {
        mcCta.textContent = lblTxt;
      }
    }
  }
  var boxSlotsBtn = root.querySelector('[data-lp-boxslots-btn]');
  function openSheet() {
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'lrc-lp-root lrc-lp-mc-ov';
      ov.appendChild(tpl.content.firstElementChild.cloneNode(true));
      document.body.appendChild(ov);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      var x = ov.querySelector('[data-lp-mc-x]');
      if (x) x.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      var mcCta = ov.querySelector('[data-lp-mc-cta]');
      if (mcCta) mcCta.addEventListener('click', function () {
        close();
        if (stickyCta) stickyCta.click(); /* reuses the full checkout / scroll-to-picker branch */
      });
    }
    fillSheet();
    lock();
    ov.style.display = '';
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
  }
  slotsBtn.addEventListener('click', openSheet);
  if (boxSlotsBtn) boxSlotsBtn.addEventListener('click', openSheet);
})();
